<div class="progress-container">
    <div class="progress-item">
      <div class="percentage" [style.color]="trainingPlanProgressKPIColor">{{ trainingPlanProgressKPI }}</div>
      <button class="custom-button" [style.backgroundColor]="trainingPlanProgressKPIColor">Training Plan Progress</button>
    </div>
    <div class="progress-item">
      <div class="percentage" [style.color]="coreCompleteKPIColor">{{ coreCompleteKPI }}</div>
      <button class="custom-button" [style.backgroundColor]="coreCompleteKPIColor">Core Complete</button>
    </div>
    <div class="progress-item">
      <div class="percentage" [style.color]="electiveCompleteKPIColor">{{ electiveCompleteKPI }}</div>
      <button class="custom-button" [style.backgroundColor]="electiveCompleteKPIColor">Elective Complete</button>
    </div>
  </div>
  